import React, { useState } from 'react';

const ContactUs = () => {
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');

  const handleSendMessage = () => {
    const adminPhoneNumber = '9115223372';  
    const whatsappMessage = `Name: ${name}\nMessage: ${message}`;
    const url = `https://wa.me/${adminPhoneNumber}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="container my-5">
      <div className="card shadow-sm p-4">
        <div className="text-center mb-4">
          <h2 className="fw-light">Contact Us</h2>
          <p className="text-muted">
            At KLV Diagnostic Lab, we provide exceptional healthcare services with advanced diagnostic equipment and experienced medical professionals.
          </p>
        </div>
        <div className="row g-4">
          <div className="col-12 col-md-6">
            <div className="bg-light rounded p-3 border">
              <h5 className="mb-3">Send Message</h5>
              <div className="mb-3">
                <label htmlFor="contactName" className="form-label">Your Name</label>
                <input
                  id="contactName"
                  type="text"
                  className="form-control"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="contactMessage" className="form-label">Your Message</label>
                <textarea
                  id="contactMessage"
                  className="form-control"
                  rows="3"
                  placeholder="Enter your message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
              </div>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSendMessage}
                disabled={!name || !message}
              >
                Send Message
              </button>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="border rounded p-3">
              <h5 className="mb-3">KLV Diagnostic Lab</h5>
              <address className="mb-3">
                1117/170, Sharda Nagar Rd, Namak Factory Chauraha, Chhapeda Pulia, crossing, Sharda Nagar<br />
                Kanpur, Uttar Pradesh 208025
              </address>
              <p><strong>Phone:</strong> +91 091152 23372</p>
              <p><strong>Email:</strong> info@klvdiagnosticgmail.com</p>
              <p><strong>Hours:</strong> Mon‑Sat: 7AM ‑ 9PM</p>
              <p><strong>Emergency:</strong> Available 24/7</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
